module.exports = __webpack_public_path__ + "img/face-bind.25a71652.png";